import type { FieldRichTextProps } from "./field-rich-text.type";

import { Form } from "antd";

import { RichTextEditor } from "@/ui/rich-text-editor";

export const FieldRichText = ({
  name,
  label,
  required,
  className,
}: FieldRichTextProps) => {
  return (
    <Form.Item
      name={name}
      label={label}
      rules={required ? [{ required: true }] : undefined}
      required={required}
      className={className}
    >
      <RichTextEditor label={label} theme="snow" />
    </Form.Item>
  );
};
